import { apiConfig } from '../api-config';

export interface CreateAddressUserParams {
  tokenKey: string;
  cdAgent: string;
  cdUser: string;
  address: string;
  number: string | number;
  neighborhood: string;
  complement: string;
  city: string;
  state: string;
  zipCode: string;
}

export const createAddressUser = (data: CreateAddressUserParams) => apiConfig
  .post('/api/Agent/BillingAddress', data)
  .catch((err) => ({ hasErrors: true, err: err.message }));
